<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-02 17:14:06
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-02 17:27:44
 * @FilePath: \YHB_H5\src\pages\agreement\privacypolicy.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
    <div style="width: 95%;margin: auto;">
        <!-- <rich-text :nodes="introduce"></rich-text> -->
        <div class="agreement" v-html="introduce"></div>
    </div>
</template>

<script>
import { getRegisteredAgreement } from "@/api/index"
export default {
    data() {
        return {
            introduce: ''
        }
    },
    created() {
        let id = this.$route.query.id || 15
        let rId = this.$route.query.rid
        let data = {
            articleTypes: [id]
        }
        getRegisteredAgreement(data).then(res => {
            if (res.code == 200) {
                let arr = []
                arr = res.data.find(item => item.id == rId)
                if (!arr) return this.introduce = res.data[0].content.replace(/\<img/gi, '<img style="width:100%"')
                this.introduce = arr.content.replace(/\<img/gi, '<img style="width:100%"')
            } else {
                uni.showToast({
                    title: res.msg,
                    icon: 'none'
                })
            }
        })

    },
    methods: {

    }
}
</script>

<style lang="scss"></style>
